import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import MonthlyReport from "../components/monthlyReport.jsx";
import Footer from "../components/footer.jsx";

function MonthlyReportpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <MonthlyReport/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default MonthlyReportpage;
